<template>
  <div v-if="legalDocuments">
    <popup-add-legal-document ref="popupAddLegalDocument" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Legal documents</h3>
        <p class="mt-5">
          Legal documents are dynamic rich text documents that has one or more
          consent types attached. A legal document can be used together with a
          dynamic form and in booking setup.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            v-if="hasPermission('vp.crm.legaldocuments.edit')"
            class="vs-con-loading__container"
            @click="$refs.popupAddLegalDocument.show()"
            type="relief"
            vslor="primary"
            >Add document</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <Loading v-if="isLoading" />
    <div v-else class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        max-items="999"
        v-model="selected"
        pagination
        search
        :data="legalDocuments"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="permissions">Number of permissions</vs-th>
          <vs-th sort-key="isEnabled">Enabled</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="font-medium">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.permissions.length }} permissions
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="status-category">
                  <vs-chip
                    :color="tr.isEnabled | yesnocolor"
                    class="status-circle"
                  ></vs-chip>
                  {{ tr.isEnabled | yesno }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PopupAddLegalDocument from "./PopupAddLegalDocument.vue";
import { mapGetters } from "vuex";
export default {
  components: { PopupAddLegalDocument },
  data() {
    return {
      newMessageTitle: "",
      selected: [],
      isLoading: false,
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "crm-legaldocument",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Profile lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      legalDocuments: "legalDocuments/documents",
    }),
  },

  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch("legalDocuments/getAll");
    this.isLoading = false;
  },
};
</script>
